import { Routes } from '@angular/router';
import { AmbassadorLayoutComponent, DefaultLayoutComponent, LoginLayoutComponent } from './containers';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
// Layout para usuarios autenticados
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    data: { roles: 'Administrador' },
    children: [
      {
        path: '',
        redirectTo: 'admin/program',
        pathMatch: 'full'
      },
      // Home oculta, no está en uso
      // {
      //   path: '',
      //   redirectTo: 'home',
      //   pathMatch: 'full'
      // },
      // {
      //   path: 'home',
      //   loadChildren: () =>
      //     import('./components/home/home.routes').then(m => m.homeRoutes), data: { roles: 'Administrador' }
      // },
      {
        path: 'home',
        redirectTo: 'admin/program',
        pathMatch: 'full'
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./components/admin/admin.routes').then(m => m.adminRoutes), data: { roles: 'Administrador' }
      }
    ]
  },
  // Layout para login
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('./components/login/login.routes').then(m => m.loginRoutes)
      }
    ]
  },
  //Layout para ambassador
  {
    path: '',
    component: AmbassadorLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'ambassador-login',
        pathMatch: 'full'
      },
      {
        path: 'ambassador-login/:idAmbassador',
        loadComponent: () =>
          import('./components/ambassador-login/ambassador-login.component').then(m => m.AmbassadorLoginComponent)
      },
      {
        path: 'ambassador-home',
        loadComponent: () =>
          import('./components/ambassador-home/ambassador-home.component').then(m => m.AmbassadorHomeComponent)
      },
      {
        path: 'ambassador-book/:idVehicle',
        loadComponent: () =>
          import('./components/ambassador-book/ambassador-book.component').then(m => m.AmbassadorBookComponent)
      }
    ]
  },
  // Fallback
  {
    path: '**',
    component: NotFoundComponent
  }
];
